var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "basket-user", attrs: { id: "login-change" } },
    [
      _vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                staticClass: "dropdown-toggle basket-user__icon btn",
                attrs: {
                  href: "#",
                  id: "accountMenuList",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  "data-boundary": "window"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "icon icon-user d-sm-none",
                    attrs: { fill: "currentColor" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#user" } })]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "d-none d-lg-block" }, [
                  _vm._v(
                    _vm._s(
                      _vm.$translate("Ceres::Template.loginHello", {
                        username: _vm.username
                      })
                    )
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "account-menu dropdown-menu dropdown-menu-right small"
              },
              [
                _c("h6", { staticClass: "dropdown-header" }, [
                  _vm._v("Benutzerkonto")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.$ceres.urls.myAccount }
                  },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.$translate("Ceres::Template.loginMyAccount"))
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    directives: [{ name: "logout", rawName: "v-logout" }],
                    staticClass: "dropdown-item",
                    attrs: { href: "#" }
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$translate("Ceres::Template.loginLogout"))
                    )
                  ]
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoggedIn
        ? _c("div", { staticClass: "dropdown" }, [
            _c(
              "a",
              {
                staticClass: "dropdown-toggle basket-user__icon btn",
                attrs: {
                  href: "#",
                  id: "accountMenuList",
                  "data-toggle": "dropdown",
                  "aria-haspopup": "true",
                  "aria-expanded": "false",
                  "data-boundary": "window"
                }
              },
              [
                _c(
                  "svg",
                  {
                    staticClass: "icon icon-user",
                    attrs: { fill: "currentColor" }
                  },
                  [_c("use", { attrs: { "xlink:href": "#user" } })]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "account-menu dropdown-menu dropdown-menu-right small"
              },
              [
                _c("h6", { staticClass: "dropdown-header" }, [
                  _vm._v("Benutzerkonto")
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      href: _vm.isLogin ? "javascript:void(0)" : "#login",
                      "data-toggle": _vm.isLogin ? false : "modal",
                      "aria-label": _vm.$translate("Ceres::Template.login"),
                      "data-testing": "login-select"
                    },
                    on: {
                      click: function($event) {
                        _vm.createLoginModal()
                        _vm.unmarkInputFields()
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "hidden-xs-down" }, [
                      _vm._v(_vm._s(_vm.$translate("Ceres::Template.login")))
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.$ceres.urls.registration + "?b2c" }
                  },
                  [
                    _c("span", { staticClass: "hidden-xs-down" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODKleinMore::Template.loginRegisterB2C"
                          )
                        )
                      )
                    ])
                  ]
                ),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    attrs: { href: _vm.$ceres.urls.registration + "?b2b" }
                  },
                  [
                    _c("span", { staticClass: "hidden-xs-down" }, [
                      _vm._v(
                        _vm._s(
                          _vm.$translate(
                            "ODKleinMore::Template.loginRegisterB2B"
                          )
                        )
                      )
                    ])
                  ]
                )
              ]
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }